// extracted by mini-css-extract-plugin
export default {"default":"Label_default__Cic1C","outlined":"Label_outlined__OCC1u","primaryColor":"Label_primaryColor__wr5IR"};